import axios from 'axios';

Shopify.functions.applyDiscountCode = async function applyDiscountCode(discountCode) {
  const url = `/discount/${discountCode}`;
  try {
    const response = await axios.get(url);
    if (!response.status === 200 || !discountCode) return null;
    return discountCode;
  } catch (error) {}
};
